const styles = {
    global: {
        body: {
            color: "primary.900",
        },
    },
};
export default styles;
